import { GuestsPlatformConfirmationsStats } from 'types/guest.types';

export enum PlatformMapping {
  calendar = 'Calendar',
  slack = 'Slack',
  eventPage = 'Event page'
}

export interface FormattedRegistrationData {
  name: string;
  value: number;
  percentage: number;
}

export const formatRegistrationsData = (
  data: GuestsPlatformConfirmationsStats = {} as GuestsPlatformConfirmationsStats
): FormattedRegistrationData[] => {
  const dataEntries = Object.entries(data);

  const validEntries = dataEntries.filter(
    ([platform, count]) => platform in PlatformMapping && count > 0
  );

  if (validEntries.length === 0) {
    return [];
  }

  const totalCount = validEntries.reduce((sum, [, count]) => sum + count, 0);

  const result = validEntries.map(([platform, count]) => {
    const mappedPlatformValue = PlatformMapping[platform as keyof typeof PlatformMapping];
    const percentage = Math.round((count / totalCount) * 100);

    return {
      name: mappedPlatformValue,
      value: count,
      percentage
    };
  });

  result.sort((a, b) => b.value - a.value);

  return result;
};
